var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { screenReaderOnlyStyle } from './styles';
function ScreenReaderOnly(_a) {
    var children = _a.children;
    return _jsx("span", __assign({ css: screenReaderOnlyStyle() }, { children: children }));
}
export default ScreenReaderOnly;
